import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { casesIndexPageMeta, casesIndexSchema } from 'components/common/schema'
import Template from 'components/cases/Case'

const Cases: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...casesIndexPageMeta} />
      <JsonLd data={casesIndexSchema} />
      <Template pageId={1} />
    </>
  )
}

export default Cases
